import { makeStyles } from '@material-ui/styles'

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(3),
  },
  results: {
    marginTop: theme.spacing(3),
  },
  tituloCampo: {
    marginBottom: theme.spacing(1),
  },
  fieldGroup: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: theme.spacing(1),
    padding: theme.spacing(1),
  },

  fieldDescricao: {
    marginTop: theme.spacing(2),
    paddingLeft: '10px',
    paddingRight: '10px',
  },
  button: {
    marginTop: '10px',
  },
  botoesFormulario: {
    marginTop: theme.spacing(2),
  },
}))

export default useStyles
